<template>
  <div class="vm-avatar-business-card">
    <div class="inner-box">
      <div class="img-box" v-if="!is_no_cover">
        <pic
          v-if="user.cover || user.avatar"
          :src="user.cover ? user.cover : user.avatar"
          :width="w"
          height="160"
        ></pic>
      </div>
      <avatar class="wh48 p16" v-if="user && user.creator" :user="user" :is_show_badge="is_show_badge" :is_no_href="is_no_href" :is_all_jump="is_all_jump">
        <div
          slot="name-right"
          class="fwn black-5 flex-item-1 flex-box flex-justify-content-space-between flex-align-items-center"
        >
          <tag v-if="!is_no_tag" class="purple ml8 flex-shrink-0">{{user.creator.category.name}}</tag>
          <i v-else></i>
          <btn v-if="is_show_sponsor_btn" class="look6">{{$t('c.AvatarBusinessCard.text1')}}</btn>
        </div>
        <div slot="doing" class="black-8 fs12 mt4">{{$t('c.AvatarBusinessCard.text2')}} {{user.creator.doing}}</div>
        <div v-if="user.user_id != 'ac0b2d20e82111eaa97952540025c377' && is_show_sponsor" slot="info" class="mt4">{{user.creator.monthly_fans}} {{$t('c.AvatarBusinessCard.text3')}}</div>
      </avatar>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "avatar-card",
  props: {
    user: {
      type: Object,
      default() {
        return null;
      }
    },
    is_no_href: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    is_show_sponsor_btn: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    is_show_badge: {
      default: function() {
        return true;
      }
    },
    is_no_tag: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    is_no_cover: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    is_all_jump: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  data() {
    return {
      w: 375
    };
  },
  computed: {
    ...mapState("app", ["browser_size"]),
    is_show_sponsor() {
      return this.user && this.user.creator && this.user.creator.privacy_public_sponsor && this.user.creator.monthly_fans > 0;
    },
  },
  beforeDestroy() {
    this.$bus.$off("WINDOW_RESIZE");
  },
  mounted() {
    this.w = this.$el.offsetWidth;
    this.$bus.$on("WINDOW_RESIZE", () => {
      this.w = this.$el.offsetWidth;
    });
  },
  methods: {}
};
</script>

<style lang="stylus" scoped>
.vm-avatar-business-card{
  border-radius: px2rem(4);
  box-shadow: $layer-shadow;
  background: $white;

  .inner-box {
    // padding-bottom px2rem(16)
  }

  .vm-avatar /deep/{
    .user-name {
      font-size: fs2rem(16);
    }
  }

  .img-box {
    width: 100%;
    height: px2rem(160);
    // padding-bottom  27.1%
    box-sizing: border-box;
    background: $white;
    border-radius: px2rem(4) px2rem(4) 0 0;
    // margin-bottom px2rem(16)
    position: relative;
    overflow: hidden;

    .vm-pic {
      border-radius: px2rem(4) px2rem(4) 0 0;
      object-fit: cover;
      height: 100%;
    }
  }
}
</style>
